module.exports = __webpack_public_path__ + "static/media/googlePin3.af34f107.svg";